// extracted by mini-css-extract-plugin
module.exports = {"spinX":"LightSwitch_spinX__CrArz","rotationX":"LightSwitch_rotationX__2ZPXZ","spinY":"LightSwitch_spinY__1O2vz","rotationY":"LightSwitch_rotationY__1oKHN"};